import { Controller } from "@hotwired/stimulus"

/**
 * Click-to-segment controller — captures a click on a scene thumbnail
 * and submits the normalised coordinates to the auto_segment_region
 * controller action.
 *
 * Usage:
 *   <div data-controller="click-segment">
 *     <img data-click-segment-target="image" src="..." />
 *     <form data-click-segment-target="form" action="..." method="post">
 *       <input data-click-segment-target="clickX" type="hidden" name="click_x" />
 *       <input data-click-segment-target="clickY" type="hidden" name="click_y" />
 *     </form>
 *     <div data-click-segment-target="marker"></div>
 *     <p data-click-segment-target="instructions">Click on the area...</p>
 *   </div>
 */
export default class ClickSegmentController extends Controller {
  static targets = ["image", "form", "clickX", "clickY", "marker", "instructions"]

  capture(event) {
    const img = this.imageTarget
    const rect = img.getBoundingClientRect()
    const x = (event.clientX - rect.left) / rect.width
    const y = (event.clientY - rect.top) / rect.height

    if (x < 0 || x > 1 || y < 0 || y > 1) return

    // Show click marker
    if (this.hasMarkerTarget) {
      const marker = this.markerTarget
      marker.style.left = `${x * 100}%`
      marker.style.top = `${y * 100}%`
      marker.style.display = "block"
    }

    // Fill hidden inputs
    this.clickXTarget.value = x.toFixed(4)
    this.clickYTarget.value = y.toFixed(4)

    // Update instructions
    if (this.hasInstructionsTarget) {
      this.instructionsTarget.textContent = `Segmenting at (${(x * 100).toFixed(0)}%, ${(y * 100).toFixed(0)}%)…`
    }

    // Submit the form
    this.formTarget.requestSubmit()
  }
}
